/* ============================================================
   Weidewild Bundle-Selector — JavaScript-Helpers
   1. Default-Selection-Forcer (gegen Mobile-Race-Condition)
   2. Single-Option-Marker: Selects mit nur 1 Option bekommen
      .wbw-single-option Klasse → CSS rendert sie als Zeile der Liste »Im Paket«
   29.10.2026 (W-1096, WK-0124): Die Ausnahme für Rücken/Braten/Filet/Keule ist raus.
   Jedes Paket ist auf genau eine Größe je Bestandteil festgelegt; die Klapplisten
   boten eine Wahl an, die es nicht gab (»Rehsteak … aus dem Rücken« fiel sogar nur
   wegen des Wortes »Rücken« darunter). Ein Feld mit zwei echten Optionen bleibt
   Klappliste — so fällt ein kaputter Optionswert (Komma-Fehler Hirsch-Paket) auf.
   ============================================================ */
(function() {
  'use strict';

  function processBundleSelectors() {
    var containers = document.querySelectorAll('[data-simple-bundles-options]');
    if (!containers.length) return false;

    var didChange = false;

    containers.forEach(function(container) {
      var selects = container.querySelectorAll('select');
      selects.forEach(function(sel) {
        // 1) Default-Selection sicherstellen
        var current = sel.options[sel.selectedIndex];
        if (!current || current.disabled || !current.value) {
          for (var i = 0; i < sel.options.length; i++) {
            var opt = sel.options[i];
            if (!opt.disabled && opt.value) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              didChange = true;
              break;
            }
          }
        }

        // 2) Single-Option-Marker — jedes Feld mit genau einer gültigen Option
        var validOptionCount = 0;
        for (var j = 0; j < sel.options.length; j++) {
          if (!sel.options[j].disabled && sel.options[j].value) validOptionCount++;
        }

        if (validOptionCount <= 1) {
          if (!sel.classList.contains('wbw-single-option')) {
            sel.classList.add('wbw-single-option');
          }
        } else {
          if (sel.classList.contains('wbw-single-option')) {
            sel.classList.remove('wbw-single-option');
          }
        }
      });
    });

    return didChange;
  }

  // Backwards-compat name
  function ensureDefaultSelection() { return processBundleSelectors(); }

  // Initial-Versuch beim DOM-Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryEnsure);
  } else {
    tryEnsure();
  }

  function tryEnsure() {
    // Sofort versuchen
    ensureDefaultSelection();

    // Plus mehrere Folge-Versuche, da App async rendert
    var attempts = 0;
    var maxAttempts = 20;
    var interval = setInterval(function() {
      attempts++;
      ensureDefaultSelection();
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 250);

    // Mutation Observer für späteren App-Render
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.addedNodes.length > 0) {
            ensureDefaultSelection();
          }
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Nach 10s Observer trennen (Performance)
      setTimeout(function() { observer.disconnect(); }, 10000);
    }
  }
})();
